import i18n from './i18n';
const { t } = i18n.global;
export const ANIMATION_DEFAULT_DURATION = 1000
export const ANIMATION_DEFAULT_TRIGGER = 'click'
export const ANIMATION_CLASS_PREFIX = 'animate__'

export const ENTER_ANIMATIONS1 = [
  {
    type: 'bounce',
    name: '弹跳',
    children: [
      { name: '弹入', value: 'bounceIn' },
      { name: '向右弹入', value: 'bounceInLeft' },
      { name: '向左弹入', value: 'bounceInRight' },
      { name: '向上弹入', value: 'bounceInUp' },
      { name: '向下弹入', value: 'bounceInDown' },
    ],
  },
  {
    type: 'fade',
    name: '浮现',
    children: [
      { name: '浮入', value: 'fadeIn' },
      { name: '向下浮入', value: 'fadeInDown' },
      { name: '向下长距浮入', value: 'fadeInDownBig' },
      { name: '向右浮入', value: 'fadeInLeft' },
      { name: '向右长距浮入', value: 'fadeInLeftBig' },
      { name: '向左浮入', value: 'fadeInRight' },
      { name: '向左长距浮入', value: 'fadeInRightBig' },
      { name: '向上浮入', value: 'fadeInUp' },
      { name: '向上长距浮入', value: 'fadeInUpBig' },
      { name: '从左上浮入', value: 'fadeInTopLeft' },
      { name: '从右上浮入', value: 'fadeInTopRight' },
      { name: '从左下浮入', value: 'fadeInBottomLeft' },
      { name: '从右下浮入', value: 'fadeInBottomRight' },
    ],
  },
  {
    type: 'rotate',
    name: '旋转',
    children: [
      { name: '旋转进入', value: 'rotateIn' },
      { name: '绕左下进入', value: 'rotateInDownLeft' },
      { name: '绕右下进入', value: 'rotateInDownRight' },
      { name: '绕左上进入', value: 'rotateInUpLeft' },
      { name: '绕右上进入', value: 'rotateInUpRight' },
    ],
  },
  {
    type: 'zoom',
    name: '缩放',
    children: [
      { name: '放大进入', value: 'zoomIn' },
      { name: '向下放大进入', value: 'zoomInDown' },
      { name: '从左放大进入', value: 'zoomInLeft' },
      { name: '从右放大进入', value: 'zoomInRight' },
      { name: '向上放大进入', value: 'zoomInUp' },
    ],
  },
  {
    type: 'slide',
    name: '滑入',
    children: [
      { name: '向下滑入', value: 'slideInDown' },
      { name: '从右滑入', value: 'slideInLeft' },
      { name: '从左滑入', value: 'slideInRight' },
      { name: '向上滑入', value: 'slideInUp' },
    ],
  },
  {
    type: 'flip',
    name: '翻转',
    children: [
      { name: 'X轴翻转进入', value: 'flipInX' },
      { name: 'Y轴翻转进入', value: 'flipInY' },
    ],
  },
  {
    type: 'back',
    name: '放大滑入',
    children: [
      { name: '向下放大滑入', value: 'backInDown' },
      { name: '从左放大滑入', value: 'backInLeft' },
      { name: '从右放大滑入', value: 'backInRight' },
      { name: '向上放大滑入', value: 'backInUp' },
    ],
  },
  {
    type: 'lightSpeed',
    name: '飞入',
    children: [
      { name: '从右飞入', value: 'lightSpeedInRight' },
      { name: '从左飞入', value: 'lightSpeedInLeft' },
    ],
  },
]

export const EXIT_ANIMATIONS1 = [
  {
    type: 'bounce',
    name: '弹跳',
    children: [
      { name: '弹出', value: 'bounceOut' },
      { name: '向左弹出', value: 'bounceOutLeft' },
      { name: '向右弹出', value: 'bounceOutRight' },
      { name: '向上弹出', value: 'bounceOutUp' },
      { name: '向下弹出', value: 'bounceOutDown' },
    ],
  },
  {
    type: 'fade',
    name: '浮现',
    children: [
      { name: '浮出', value: 'fadeOut' },
      { name: '向下浮出', value: 'fadeOutDown' },
      { name: '向下长距浮出', value: 'fadeOutDownBig' },
      { name: '向左浮出', value: 'fadeOutLeft' },
      { name: '向左长距浮出', value: 'fadeOutLeftBig' },
      { name: '向右浮出', value: 'fadeOutRight' },
      { name: '向右长距浮出', value: 'fadeOutRightBig' },
      { name: '向上浮出', value: 'fadeOutUp' },
      { name: '向上长距浮出', value: 'fadeOutUpBig' },
      { name: '从左上浮出', value: 'fadeOutTopLeft' },
      { name: '从右上浮出', value: 'fadeOutTopRight' },
      { name: '从左下浮出', value: 'fadeOutBottomLeft' },
      { name: '从右下浮出', value: 'fadeOutBottomRight' },
    ],
  },
  {
    type: 'rotate',
    name: '旋转',
    children: [
      { name: '旋转退出', value: 'rotateOut' },
      { name: '绕左下退出', value: 'rotateOutDownLeft' },
      { name: '绕右下退出', value: 'rotateOutDownRight' },
      { name: '绕左上退出', value: 'rotateOutUpLeft' },
      { name: '绕右上退出', value: 'rotateOutUpRight' },
    ],
  },
  {
    type: 'zoom',
    name: '缩放',
    children: [
      { name: '缩小退出', value: 'zoomOut' },
      { name: '向下缩小退出', value: 'zoomOutDown' },
      { name: '从左缩小退出', value: 'zoomOutLeft' },
      { name: '从右缩小退出', value: 'zoomOutRight' },
      { name: '向上缩小退出', value: 'zoomOutUp' },
    ],
  },
  {
    type: 'slide',
    name: '滑出',
    children: [
      { name: '向下滑出', value: 'slideOutDown' },
      { name: '从左滑出', value: 'slideOutLeft' },
      { name: '从右滑出', value: 'slideOutRight' },
      { name: '向上滑出', value: 'slideOutUp' },
    ],
  },
  {
    type: 'flip',
    name: '翻转',
    children: [
      { name: 'X轴翻转退出', value: 'flipOutX' },
      { name: 'Y轴翻转退出', value: 'flipOutY' },
    ],
  },
  {
    type: 'back',
    name: '缩小滑出',
    children: [
      { name: '向下缩小滑出', value: 'backOutDown' },
      { name: '从左缩小滑出', value: 'backOutLeft' },
      { name: '从右缩小滑出', value: 'backOutRight' },
      { name: '向上缩小滑出', value: 'backOutUp' },
    ],
  },
  {
    type: 'lightSpeed',
    name: '飞出',
    children: [
      { name: '从右飞出', value: 'lightSpeedOutRight' },
      { name: '从左飞出', value: 'lightSpeedOutLeft' },
    ],
  },
]

export const ATTENTION_ANIMATIONS1 = [
  {
    type: 'shake',
    name: '晃动',
    children: [
      { name: '左右摇晃', value: 'shakeX' },
      { name: '上下摇晃', value: 'shakeY' },
      { name: '摇头', value: 'headShake' },
      { name: '摆动', value: 'swing' },
      { name: '晃动', value: 'wobble' },
      { name: '惊恐', value: 'tada' },
      { name: '果冻', value: 'jello' },
    ],
  },
  {
    type: 'other',
    name: '其他',
    children: [
      { name: '弹跳', value: 'bounce' },
      { name: '闪烁', value: 'flash' },
      { name: '脉搏', value: 'pulse' },
      { name: '橡皮筋', value: 'rubberBand' },
      { name: '心跳（快）', value: 'heartBeat' },
    ],
  },
]
// changelanguage
export const ENTER_ANIMATIONS = [
  {
    type: 'bounce',
    name: t(`animation.in.bounce`),
    children: [
      { name: t(`animation.in.bounceIn`), value: 'bounceIn' },
      { name: t(`animation.in.bounceInLeft`), value: 'bounceInLeft' },
      { name: t(`animation.in.bounceInRight`), value: 'bounceInRight' },
      { name: t(`animation.in.bounceInUp`), value: 'bounceInUp' },
      { name: t(`animation.in.bounceInDown`), value: 'bounceInDown' },
    ],
  },
  {
    type: 'fade',
    name: t(`animation.in.fade`),
    children: [
      { name: t(`animation.in.fadeIn`), value: 'fadeIn' },
      { name: t(`animation.in.fadeInDown`), value: 'fadeInDown' },
      { name: t(`animation.in.fadeInDownBig`), value: 'fadeInDownBig' },
      { name: t(`animation.in.fadeInLeft`), value: 'fadeInLeft' },
      { name: t(`animation.in.fadeInLeftBig`), value: 'fadeInLeftBig' },
      { name: t(`animation.in.fadeInRight`), value: 'fadeInRight' },
      { name: t(`animation.in.fadeInRightBig`), value: 'fadeInRightBig' },
      { name: t(`animation.in.fadeInUp`), value: 'fadeInUp' },
      { name: t(`animation.in.fadeInUpBig`), value: 'fadeInUpBig' },
      { name: t(`animation.in.fadeInTopLeft`), value: 'fadeInTopLeft' },
      { name: t(`animation.in.fadeInTopRight`), value: 'fadeInTopRight' },
      { name: t(`animation.in.fadeInBottomLeft`), value: 'fadeInBottomLeft' },
      { name: t(`animation.in.fadeInBottomRight`), value: 'fadeInBottomRight' },
    ],
  },
  {
    type: 'rotate',
    name: t(`animation.in.rotate`),
    children: [
      { name: t(`animation.in.rotateIn`), value: 'rotateIn' },
      { name: t(`animation.in.rotateInDownLeft`), value: 'rotateInDownLeft' },
      { name: t(`animation.in.rotateInDownRight`), value: 'rotateInDownRight' },
      { name: t(`animation.in.rotateInUpLeft`), value: 'rotateInUpLeft' },
      { name: t(`animation.in.rotateInUpRight`), value: 'rotateInUpRight' },
    ],
  },
  {
    type: 'zoom',
    name: t(`animation.in.zoom`),
    children: [
      { name: t(`animation.in.zoomIn`), value: 'zoomIn' },
      { name: t(`animation.in.zoomInDown`), value: 'zoomInDown' },
      { name: t(`animation.in.zoomInLeft`), value: 'zoomInLeft' },
      { name: t(`animation.in.zoomInRight`), value: 'zoomInRight' },
      { name: t(`animation.in.zoomInUp`), value: 'zoomInUp' },
    ],
  },
  {
    type: 'slide',
    name: t(`animation.in.slide`),
    children: [
      { name: t(`animation.in.slideInDown`), value: 'slideInDown' },
      { name: t(`animation.in.slideInLeft`), value: 'slideInLeft' },
      { name: t(`animation.in.slideInRight`), value: 'slideInRight' },
      { name: t(`animation.in.slideInUp`), value: 'slideInUp' },
    ],
  },
  {
    type: 'flip',
    name: t(`animation.in.flip`),
    children: [
      { name: t(`animation.in.flipInX`), value: 'flipInX' },
      { name: t(`animation.in.flipInY`), value: 'flipInY' },
    ],
  },
  {
    type: 'back',
    name: t(`animation.in.flip`),
    children: [
      { name: t(`animation.in.backInDown`), value: 'backInDown' },
      { name: t(`animation.in.backInLeft`), value: 'backInLeft' },
      { name: t(`animation.in.backInRight`), value: 'backInRight' },
      { name: t(`animation.in.backInUp`), value: 'backInUp' },
    ],
  },
  {
    type: 'lightSpeed',
    name: t(`animation.in.lightSpeed`),
    children: [
      { name: t(`animation.in.lightSpeedInRight`), value: 'lightSpeedInRight' },
      { name: t(`animation.in.lightSpeedInLeft`), value: 'lightSpeedInLeft' },
    ],
  },
]

export const EXIT_ANIMATIONS = [
  {
    type: 'bounce',
    name: t(`animation.out.bounce`),
    children: [
      { name: t(`animation.out.bounceOut`), value: 'bounceOut' },
      { name: t(`animation.out.bounceOutLeft`), value: 'bounceOutLeft' },
      { name: t(`animation.out.bounceOutRight`), value: 'bounceOutRight' },
      { name: t(`animation.out.bounceOutUp`), value: 'bounceOutUp' },
      { name: t(`animation.out.bounceOutDown`), value: 'bounceOutDown' },
    ],
  },
  {
    type: 'fade',
    name: t(`animation.out.fade`),
    children: [
      { name: t(`animation.out.fadeOut`), value: 'fadeOut' },
      { name: t(`animation.out.fadeOutDown`), value: 'fadeOutDown' },
      { name: t(`animation.out.fadeOutDownBig`), value: 'fadeOutDownBig' },
      { name: t(`animation.out.fadeOutLeft`), value: 'fadeOutLeft' },
      { name: t(`animation.out.fadeOutLeftBig`), value: 'fadeOutLeftBig' },
      { name: t(`animation.out.fadeOutRight`), value: 'fadeOutRight' },
      { name: t(`animation.out.fadeOutRightBig`), value: 'fadeOutRightBig' },
      { name: t(`animation.out.fadeOutUp`), value: 'fadeOutUp' },
      { name: t(`animation.out.fadeOutUpBig`), value: 'fadeOutUpBig' },
      { name: t(`animation.out.fadeOutTopLeft`), value: 'fadeOutTopLeft' },
      { name: t(`animation.out.fadeOutTopRight`), value: 'fadeOutTopRight' },
      { name: t(`animation.out.fadeOutBottomLeft`), value: 'fadeOutBottomLeft' },
      { name: t(`animation.out.fadeOutBottomRight`), value: 'fadeOutBottomRight' },
    ],
  },
  {
    type: 'rotate',
    name: t(`animation.out.rotate`),
    children: [
      { name: t(`animation.out.rotateOut`), value: 'rotateOut' },
      { name: t(`animation.out.rotateOutDownLeft`), value: 'rotateOutDownLeft' },
      { name: t(`animation.out.rotateOutDownRight`), value: 'rotateOutDownRight' },
      { name: t(`animation.out.rotateOutUpLeft`), value: 'rotateOutUpLeft' },
      { name: t(`animation.out.rotateOutUpRight`), value: 'rotateOutUpRight' },
    ],
  },
  {
    type: 'zoom',
    name: t(`animation.out.zoom`),
    children: [
      { name: t(`animation.out.zoomOut`), value: 'zoomOut' },
      { name: t(`animation.out.zoomOutDown`), value: 'zoomOutDown' },
      { name: t(`animation.out.zoomOutLeft`), value: 'zoomOutLeft' },
      { name: t(`animation.out.zoomOutRight`), value: 'zoomOutRight' },
      { name: t(`animation.out.zoomOutUp`), value: 'zoomOutUp' },
    ],
  },
  {
    type: 'slide',
    name: t(`animation.out.slide`),
    children: [
      { name: t(`animation.out.slideOutDown`), value: 'slideOutDown' },
      { name: t(`animation.out.slideOutLeft`), value: 'slideOutLeft' },
      { name: t(`animation.out.slideOutRight`), value: 'slideOutRight' },
      { name: t(`animation.out.slideOutUp`), value: 'slideOutUp' },
    ],
  },
  {
    type: 'flip',
    name: t(`animation.out.flip`),
    children: [
      { name: t(`animation.out.flipOutX`), value: 'flipOutX' },
      { name: t(`animation.out.flipOutY`), value: 'flipOutY' },
    ],
  },
  {
    type: 'back',
    name: t(`animation.out.back`),
    children: [
      { name: t(`animation.out.backOutDown`), value: 'backOutDown' },
      { name: t(`animation.out.backOutLeft`), value: 'backOutLeft' },
      { name: t(`animation.out.backOutRight`), value: 'backOutRight' },
      { name: t(`animation.out.backOutUp`), value: 'backOutUp' },
    ],
  },
  {
    type: 'lightSpeed',
    name: t(`animation.out.lightSpeed`),
    children: [
      { name: t(`animation.out.lightSpeedOutRight`), value: 'lightSpeedOutRight' },
      { name: t(`animation.out.lightSpeedOutLeft`), value: 'lightSpeedOutLeft' },
    ],
  },
]

export const ATTENTION_ANIMATIONS = [
  {
    type: 'shake',
    name: t(`animation.attention.shake`),
    children: [
      { name: t(`animation.attention.shakeX`), value: 'shakeX' },
      { name: t(`animation.attention.shakeY`), value: 'shakeY' },
      { name: t(`animation.attention.headShake`), value: 'headShake' },
      { name: t(`animation.attention.swing`), value: 'swing' },
      { name: t(`animation.attention.wobble`), value: 'wobble' },
      { name: t(`animation.attention.tada`), value: 'tada' },
      { name: t(`animation.attention.jello`), value: 'jello' },
    ],
  },
  {
    type: 'other',
    name: t(`animation.attention.other`),
    children: [
      { name: t(`animation.attention.bounce`), value: 'bounce' },
      { name: t(`animation.attention.flash`), value: 'flash' },
      { name: t(`animation.attention.pulse`), value: 'pulse' },
      { name: t(`animation.attention.rubberBand`), value: 'rubberBand' },
      { name: t(`animation.attention.heartBeat`), value: 'heartBeat' },
    ],
  },
]
